export const homepageurl = "/";
export const aboutusurl = "/about-us";
export const termsofuse = "/terms-of-use";
export const cookiepolicy = "/cookie-policy";
export const privacypolicy = "/privacy-policy";
export const investorURL = "investor";
